export const cdnPath = 'https://images.angelstudios.com/image/upload'
